import axios from "axios";
import Config from "../../../config/config";

const v2_actionCliente = (cpf) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.api_dev : Config.api_prod}/api/v2/apps/pdv/clientes/cpf/${cpf}`
    });
};

export default v2_actionCliente;
